import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { useQuery } from "../../../Utils/utils"

// The business account every Receipt screen reads.
//
// Support's admin copies of these pages (Business settings → Receipt) carry
// their target account in the URL as `?business_account_id=...`, put there by
// BusinessSettings/index.js and preserved by its sidebar and ConfigureTabs.
// Everywhere else — and whenever that parameter is missing — it is the viewer's
// own session BA.
//
// This mirrors what the server does with the same parameter: only a support
// admin's is acted on, a merchant always resolves to their session BA whatever
// is sent (chargeback_back consumer_clarity/services/configure_access.py).
export const useReceiptBusinessId = (usersViewForAdmin) => {
  const { search } = useLocation()
  const query = useQuery(search)
  const businessAccountIdFromQuery = query.get("business_account_id")
  const currentBusinessAccountId = useSelector((s) => s.auth?.userInfo?.current_business_account_id)

  return usersViewForAdmin && businessAccountIdFromQuery
    ? businessAccountIdFromQuery
    : currentBusinessAccountId
}
